import React, { ReactNode, useState, useContext, createContext } from 'react';
import {
  ISortBy,
  SortByLastUpdateRecentFirst,
  SortByTitleAsc,
  SortByTitleDesc
} from '../../Models/sortby.model';
import { ITripModelSummary } from '../../Models/trips/trip-summary.model';

interface TripsContextType {
  trips: ITripModelSummary[];
  setTrips: (trips: ITripModelSummary[]) => void;
  activeTrip: ITripModelSummary | undefined;
  setActiveTrip: (trip: ITripModelSummary) => void;
  // sort: ISortBy;
  // setSort: (sort: ISortBy) => void;
  // page: number;
  // setPage: (page: number) => void;
  // pageSize: number;
  // setPageSize: (pageSize: number) => void;
  refreshTrips: boolean;
  setRefreshTrips: (refreshTrips: boolean) => void;
  // showAddTripModal: boolean;
  // setShowAddTripModal: (state: boolean) => void;
  // showDeleteModal: boolean;
  // setShowDeleteModal: (state: boolean) => void;
  // showEditTripModal: boolean;
  // setShowEditTripModal: (state: boolean) => void;
  // showPublishTripModal: boolean;
  // setShowPublishTripModal: (state: boolean) => void;
  // showCopyModal: boolean;
  // setShowCopyModal: (state: boolean) => void;
  // showMoveToTripModal: boolean;
  // setShowMoveToTripModal: (state: boolean) => void;
}

const TripsContext = createContext<TripsContextType | undefined>(undefined);

const TripsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [trips, setTrips] = useState<ITripModelSummary[]>([]);
  // const [sort, setSort] = useState<ISortBy>(SortByTitleDesc);
  // const [page, setPage] = useState<number>(1);
  // const [pageSize, setPageSize] = useState<number>(10);
  const [refreshTrips, setRefreshTrips] = useState<boolean>(false);
  // const [showAddTripModal, setShowAddTripModal] = useState<boolean>(false);
  // const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  // const [showEditTripModal, setShowEditTripModal] = useState<boolean>(false);
  // const [showPublishTripModal, setShowPublishTripModal] =
  //   useState<boolean>(false);
  // const [showCopyModal, setShowCopyModal] = useState<boolean>(false);
  // const [showMoveToTripModal, setShowMoveToTripModal] =
  //   useState<boolean>(false);
  const [activeTrip, setActiveTrip] = useState<ITripModelSummary | undefined>(
    undefined
  );

  return (
    <TripsContext.Provider
      value={{
        trips,
        setTrips,
        // sort,
        // setSort,
        // page,
        // setPage,
        // pageSize,
        // setPageSize,
        refreshTrips,
        setRefreshTrips,
        // showAddTripModal,
        // setShowAddTripModal,
        // showDeleteModal,
        // setShowDeleteModal,
        // showEditTripModal,
        // setShowEditTripModal,
        // showPublishTripModal,
        // setShowPublishTripModal,
        // showCopyModal,
        // setShowCopyModal,
        // showMoveToTripModal,
        // setShowMoveToTripModal
        activeTrip,
        setActiveTrip
      }}
    >
      {children}
    </TripsContext.Provider>
  );
};

const useTrips = () => {
  const context = useContext(TripsContext);
  if (context === undefined || context.trips === undefined) {
    throw new Error('useTrip must be used within a TripProvider');
  }
  return context;
};

/** Returns the context, or null when used outside a TripsProvider. */
const useTripsOptional = (): TripsContextType | null => {
  return useContext(TripsContext) ?? null;
};

export { TripsProvider, useTrips, useTripsOptional };
